import api from '../../../api'
import _ from 'lodash'

export default {
    getPurchases: (payload, next) => {
        api.get('/stripe/paymentintents?customer=' + payload.query.userId, (err, data) => {
            if(err) return next(err, null);
            
            next(null, data);
        });
    },
    updatePurchases: (payload, next) => {
        api.put('/stripe/paymentintents/' + payload.query.paymentIntentId, payload.body, (err, data) => {
            if(err) return next(err, null);
            
            next(null, data);
        });
    },
    getPlansByProductName : (payload, next) => {
        api.get('/stripe/plans?productName=' + payload.query.productName, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    createCustomer : (payload, next) => {
        api.post('/stripe/customers?userId=' + payload.query.userId, payload.body, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    createSubscription : (payload, next) => {
        api.post('/stripe/subscriptions', payload.body, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    },
    checkCoupon : (payload, next) => {
        api.get('/stripe/coupons/' + payload.query.couponCode, (err, data) => {
            if(err) return next(err, null);

            next(null, data);
        })   
    }
} 



// WEBPACK FOOTER //
// ./src/libs/system/services/stripe.js